import { useState } from "react";
import { Form, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./EditableName.scss";

const EditableName = ({ value = "", onChange }) => {
  const [name, setName] = useState(value);
  const [isEditing, setIsEditing] = useState(false);

  const onEdit = () => {
    setIsEditing(true);
  };
  const onSave = () => {
    onChange(name);
    setIsEditing(false);
  };
  const onCancel = () => {
    setName(value);
    setIsEditing(false);
  };
  const handleChange = (e) => {
    setName(e.target.value);
  };

  return (
    <div>
      {isEditing ? (
        <div className="d-flex gap-1">
          <Form.Control
            className="p-1"
            type="text"
            placeholder="Input a match name"
            defaultValue={name}
            onChange={handleChange}
          />
          <Button variant="secondary" onClick={onSave}>
            <FontAwesomeIcon icon={["fas", "save"]} />
          </Button>
          <Button variant="secondary" onClick={onCancel}>
            <FontAwesomeIcon icon={["fas", "xmark"]} />
          </Button>
        </div>
      ) : (
        <div>
          <span className="editable-name" onClick={onEdit}>
            {name}
          </span>
        </div>
      )}
    </div>
  );
};

export default EditableName;
